module.exports = __webpack_public_path__ + "officialStatic/img/productB38.bc9f284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB38.png
// module id = zlG2
// module chunks = 0